import { useState, useRef, useLayoutEffect, useEffect } from "react";
import VisionLoading from "../../../components/Lottie/VisionLoading";
import ToggleButton from "../../../components/Booking/ToggleButton";
import BoxCountInfoModal from "../../../components/Booking/BoxCountInfoModal";
import PopularItems from "../../../components/Booking/PopularItems";
import ReusableModal from "../../../components/Booking/ReusableModal";
import CustomTooltip from "../../../components/Booking/CustomTooltip";
import TrashIcon from "../../../components/Icons/TrashIconItems";
import DocumentIcon from "../../../components/Icons/EditNote";
import { get } from "idb-keyval";
import DisassemblyReassembly from "../../../components/Booking/DisassemblyReassembly";


const VisionItemsScreen = ({
  // Props for vision data
  visionLoading,
  items,


  // Props for catalog functionality
  addItems,
  setAddItems,
  selectedBookingItemsFromCatlog,


  // Props for UI state

  handleUpdateBookingObject,
  boxAndBagsCount,


  // Props for functions

  decrementBookingItem,
  incrementBookingItem,
  handleAddNote,
  deleteBookingItem,
  disassemblyRequiredBookingItem,
  handleGetCatlogItems,
  handleAddCatalogItems,
  selectCatalogItem,
  removeCatalogItem,
  frontItems,
  updateItemsAndTimestamp,


}) => {

  const [noteText, setNoteText] = useState("");
  const [isBoxCountInfoModalOpen, setIsBoxCountInfoModalOpen] = useState(false);
  const [isDisassemblyInfoModalOpen, setIsDisassemblyInfoModalOpen] = useState(false);



  const getImagesFromIndexedDB = async () => {
    try {
      const images = await get("uploaded_images_persistance");
      return images || [];
    } catch (err) {
      console.error("Keyval get failed", err);
      return [];
    }
  };

  const isValidUrl = (url) =>
    typeof url === "string" &&
    url.trim() !== "" &&
    (url.startsWith("http://") || url.startsWith("https://"));


  const resolveImageSrc = (item) => {
    // pehle URL check
    if (isValidUrl(item.imageUrl)) return item.imageUrl;
    if (isValidUrl(item.imageURL)) return item.imageURL;

    // phir IndexedDB
    const indexedImg = getImageByImageId(item.ImageID);
    if (indexedImg) return indexedImg;

    // last fallback
    return "/images/moovez_frog.png";
  };





  const handleBoxesAndBagsItem = (count) => {
    const existingItems = items || [];

    // Identify by name instead of type
    const itemIndex = existingItems.findIndex(
      (item) => item.name === "Boxes & bags"
    );

    // Case 1: count > 0
    if (count > 0) {
      if (itemIndex !== -1) {
        // Item exists → update quantity
        const updatedItems = [...existingItems];
        updatedItems[itemIndex] = {
          ...updatedItems[itemIndex],
          quantity: count,
        };
        updateItemsAndTimestamp(updatedItems);
      } else {
        // Item does not exist → append
        updateItemsAndTimestamp([
          ...existingItems,
          {
            ...frontItems,
            name: "Boxes & bags",
            quantity: count,
            // category, size, volume, weight etc. can be copied from frontItems
          },
        ]);
      }
    } else {
      // Case 2: count <= 0 → remove item
      if (itemIndex !== -1) {
        const updatedItems = existingItems.filter(
          (item) => item.name !== "Boxes & bags"
        );
        updateItemsAndTimestamp(updatedItems);
      }
    }
  };




  // Local controlled state for the Add Note modal input
  // const handleNoteSubmit = () => {
  //   // Only submit when the note is non-empty
  //   if (noteText.trim()) {
  //     addNoteBookingItem(noteText);
  //     setNoteText("");
  //   }
  // };

  const [indexedImages, setIndexedImages] = useState([]);
  const itemsSectionRef = useRef(null);
  const footerRef = useRef(null);
  const [itemsListMaxHeight, setItemsListMaxHeight] = useState("200px");

  useLayoutEffect(() => {
    const calculate = () => {
      try {
        const top = itemsSectionRef.current
          ? itemsSectionRef.current.getBoundingClientRect().top
          : 0;
        const footerH = footerRef.current
          ? footerRef.current.getBoundingClientRect().height
          : 0;

        // small padding buffer (px)
        const buffer = 24;
        const available = Math.max(80, window.innerHeight - top - footerH - buffer);
        setItemsListMaxHeight(`${available}px`);
      } catch (err) {
        // fallback
        setItemsListMaxHeight("200px");
      }
    };

    calculate();
    window.addEventListener("resize", calculate);
    return () => window.removeEventListener("resize", calculate);
  }, []);

  useEffect(() => {
    getImagesFromIndexedDB().then((imgs) => {
      setIndexedImages(imgs);
    });
  }, []);

  // ✅ correct place
  const getImageByImageId = (imageId) => {
    const match = indexedImages.find(
      (img) => img.id === imageId || img.ImageID === imageId
    );

    return match?.data || match?.base64 || null;
  };



  // If data is still loading, show a dedicated loading animation
  if (visionLoading) {
    return <VisionLoading />;
  }


  // If user is in "Add Items" mode, render the catalog selection UI
  if (addItems) {
    return (
      <ReusableModal
        isOpen={addItems}
        onClose={() => setAddItems(false)}
        showLoading={false}
        showConfirm={selectedBookingItemsFromCatlog.length !== 0}
        onConfirm={() => { setAddItems(false); handleAddCatalogItems(); }}
        confirmDisabled={selectedBookingItemsFromCatlog.length === 0}
        handleUpdateBookingObject={handleUpdateBookingObject}
      >
        <PopularItems
          handleGetCatlogItems={handleGetCatlogItems}
          selectedBookingItemsFromCatlog={selectedBookingItemsFromCatlog}
          removeCatalogItem={removeCatalogItem}
          selectCatalogItem={selectCatalogItem}
          handleAddCatalogItems={handleAddCatalogItems}
        />
      </ReusableModal>
    );
  }



  return (
    <div className="flex flex-col justify-between max-w-container mx-auto h-full">


      <div className="font-instrument">
        {/* Page title */}


        <div className="text-[#211F59] text-[24px] px-[33px] font-semibold font-instrument mb-[14.45px]" style={{ lineHeight: "23px" }}>
          List of items
        </div>


        <div
          onClick={() => setIsBoxCountInfoModalOpen(true)}
          className="pt-[14px]  flex items-center  px-[33px] bg-[#E3E3FF] gap-x-1"
        >
          <p className="font-semibold text-[16px] text-[#211F59] leading-[100%] tracking-normal">
            Add your total number of boxes/bags
          </p>
          <img
            src="\images\NewUiIcons\InfoIcon.svg"
            alt="info"
            className="w-[14px] h-[14px] object-contain self-end cursor-pointer"
          />
        </div>


        {/* Static Boxes and Bags helper row (keeps original behavior/layout) */}
        <div className="bg-[#E3E3FF] h-[77.09px] flex flex-col justify-center pl-[47px]">
          <div className="flex">
            {/* Box Icon */}
            <img
              className="h-[50.16px] rounded-full"
              alt="Boxes and bags"
              src="\images\NewUiIcons\Item Icons.svg"
            />

            <div className="flex items-center justify-between ml-6">
              <div className="flex items-center">
                {/* Decrement button - fixed size to avoid layout shift */}
                <button
                  type="button"

                  onClick={() => {
                    const newCount = Math.max(0, (boxAndBagsCount || 0) - 1);

                    handleUpdateBookingObject(
                      "boxAndBagsCount",
                      newCount,
                      "boxCount.dec"
                    );

                    handleBoxesAndBagsItem(newCount);
                  }}

                  aria-label="decrement"
                >
                  <img
                    src="/images/NewUiIcons/Subtract Icon.svg"
                    alt="decrement"
                    className="w-[17px]"
                  />
                </button>

                {/* Narrower fixed-width counter to reduce gap */}
                <div
                  className="mx-2 w-6 text-center text-[16px] font-medium text-[#7876A1] tabular-nums"
                  aria-live="polite"
                >
                  {boxAndBagsCount}
                </div>

                <button
                  type="button"
                  onClick={() => {
                    const newCount = (boxAndBagsCount || 0) + 1;

                    handleUpdateBookingObject(
                      "boxAndBagsCount",
                      newCount,
                      "boxCount.inc"
                    );

                    handleBoxesAndBagsItem(newCount);
                  }}
                  aria-label="increment"
                >
                  <img
                    src="/images/NewUiIcons/Add Icon.svg"
                    alt="increment"
                    className="w-[17px]"
                  />
                </button>

                {/* Item name - small left margin to keep it close */}
                <div
                  className="ml-3 text-[14px] text-[#211F59] font-medium capitalize "

                >
                  {"Boxes & bags"}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="px-[33px] max-w-container">

        </div>

        <div ref={itemsSectionRef} className="w-full bg-[#f6f6fd] px-[33px] max-w-container">
          {items.length > 0 && !(items.length === 1 && items[0].name === "Boxes & bags") && (

            <div className="flex items-center justify-end gap-x-1 mt-[18px]">

              <img src="/images/NewUiIcons/DisassemblyIcon.svg" alt="icon" />
              <p className="text-end text-[12px] font-normal text-[#34318C] leading-[100%]">
                Disassembly/Reassembly <img src="/images/NewUiIcons/InfoIcon.svg" alt="info icon" className="inline cursor-pointer" onClick={() => setIsDisassemblyInfoModalOpen(true)} />
              </p>
            </div>
          )}
          <div className="mt-[12.45px]">
            <div>
              {/* Dynamic Items List */}

              {(items.length === 0 || (items.length === 1 && items[0].name === "Boxes & bags")) && (
                <p
                  className="
      text-center text-[14px] text-[#7876A1] font-normal mt-4 mx-auto
      max-w-[330px]
      [mask-image:linear-gradient(to bottom,white 60%,transparent 100%)]
    "
                >
                  We couldn’t detect any movable items in your uploaded image. You
                  can tap “Add Items” to select from popular items, or go back to
                  the{" "}
                  <button
                    onClick={() =>
                      handleUpdateBookingObject(
                        "tripStatus",
                        "uploadimages",
                        "trip.status.change.to.uploadimages"
                      )
                    }
                    className="underline text-[#34318C] hover:opacity-80 inline-block mr-1"
                  >
                    Upload Images
                  </button>
                  screen and upload a clearer image with visible items.
                </p>
              )}

              <div className="overflow-y-auto" style={{ maxHeight: itemsListMaxHeight }}>


                {items?.filter(item => item.name !== "Boxes & bags")  // <-- skip Boxes & bags
                  .map((item, itemIndex) => (
                    <div
                      key={itemIndex}

                      className="w-full pl-[14px] max-w-container"
                    >
                      <div className="flex items-center">
                        {/* Left icon */}
                        <div className="flex-shrink-0">
                          {/* Render image only (no background circle) */}

                          <img
                            className="w-[50px] h-[50px] rounded-full object-cover border-[2px] border-[#E3E3FF]"
                            alt={item.name}
                            src={resolveImageSrc(item)}
                          />
                        </div>

                        {/* Middle content: counters + title + actions */}
                        <div className="flex-1 ml-6 relative">
                          <div className="flex items-center justify-between">
                            <div className="flex items-center">
                              {/* Decrement button - fixed size to avoid layout shift */}
                              <button
                                type="button"
                                onClick={() => decrementBookingItem(itemIndex)}
                                aria-label="decrement"
                              >
                                <img
                                  src="/images/NewUiIcons/Subtract Icon.svg"
                                  alt="decrement"
                                  className="w-[17px]"
                                />
                              </button>

                              {/* Narrower fixed-width counter to reduce gap */}
                              <div
                                className="mx-2 w-6 text-center text-[16px] font-medium text-[#7876A1] tabular-nums"
                                aria-live="polite"
                              >
                                {item.quantity}
                              </div>
                              <button
                                type="button"
                                onClick={() => incrementBookingItem(itemIndex)}
                                aria-label="increment"
                              >
                                <img
                                  src="/images/NewUiIcons/Add Icon.svg"
                                  alt="increment"
                                  className="w-[17px]"
                                />
                              </button>

                              <CustomTooltip text={item.name}>
                                <div

                                  className="ml-3 text-[14px] text-[#211F59] font-medium capitalize truncate max-w-[120px]"

                                >

                                  {item.name}
                                </div>
                              </CustomTooltip>
                            </div>
                          </div>

                          {/* Toggle () */}
                          <ToggleButton

                            disassemblyRequiredBookingItem={
                              disassemblyRequiredBookingItem
                            }
                            itemIndex={itemIndex}
                            item={item}
                          />

                          <div className="flex items-center gap-6 mt-2 text-[14px] text-[#6B6899]">

                            {/* Add/Edit Note */}
                            <div
                              className="flex items-center cursor-pointer group"
                              onClick={() => handleAddNote(itemIndex)}
                            >
                              {/* Icon */}
                              <DocumentIcon className="text-[#7876A1] group-hover:text-[#34318C] transition-colors duration-200" />

                              {/* Text */}
                              <span className="text-[10px] ml-[6px] text-[#7876A1] font-semibold group-hover:text-[#34318C] transition-colors duration-200">
                                {item.note ? "Edit note" : "Add note"}
                              </span>
                            </div>

                            {/* Remove */}
                            <div
                              className="flex items-center cursor-pointer group"
                              onClick={() => deleteBookingItem(itemIndex)}
                            >
                              {/* Icon */}
                              <TrashIcon className="text-[#7876A1] group-hover:text-[#990f02] transition-colors duration-200" />

                              {/* Text */}
                              <span className="text-[10px] ml-[6px] text-[#7876A1] font-semibold group-hover:text-[#990f02] transition-colors duration-200">
                                Remove
                              </span>
                            </div>

                          </div>




                        </div>

                      </div>
                      {
                        item.note && (

                          <h5

                            className="text-[#7876A1] text-[10px] max-w-[188.92px] font-instrument whitespace-normal break-words mt-2 ml-[73px]"
                          >
                            {item.note}
                          </h5>
                        )
                      }
                      <hr
                        style={{ borderBottom: "1px solid #CDCCD7", marginTop: "12px", marginBottom: "12px" }}
                      />
                    </div>
                  ))}
              </div>
            </div>


          </div>


        </div>


        {isBoxCountInfoModalOpen ? (
          <BoxCountInfoModal onClose={() => setIsBoxCountInfoModalOpen(false)} />
        ) : null}

        {isDisassemblyInfoModalOpen ? (
          <DisassemblyReassembly onClose={() => setIsDisassemblyInfoModalOpen(false)} />
        ) : null}




      </div>
      <div ref={footerRef} className="px-[33px] w-full">

        <div
          className={`h-[44.38px] w-full cursor-pointer text-[#4743BF] text-[16px] font-semibold flex items-center
          justify-center rounded-[15px] bg-[#F6F6F6] border-[1px] my-[15px] border-[#7876A1]`}
          onClick={() => setAddItems(true)}
        >
          Add Items
        </div>

      </div>

    </div>
  );
};

export default VisionItemsScreen;


